import {ReactNode} from "react";
import "./style.scss";

const CardWrapper = ({children}: {children: ReactNode}) => {
	return <div className="card-wrapper">{children}</div>;
};

export default CardWrapper;
